export const BreakGameParts = [
    "BreakAfterFirstOvertime",
    "BreakAfterSecondOvertime",
    "BreakAfterFirstPeriod",
    "BreakAfterSecondPeriod",
    "BreakAfterThirdPeriod",
    "BreakAfterFirstQuarter",
    "BreakAfterSecondQuarter",
    "BreakAfterThirdQuarter",
    "BreakAfterFourthQuarter",
    "BreakAfterFirstHalf",
    "BreakAfterFirstInning",
    "BreakAfterSecondInning",
    "BreakAfterThirdInning",
    "BreakAfterFourthInning",
    "BreakAfterFifthInning",
    "BreakAfterSixthInning",
    "BreakAfterSeventhInning",
    "BreakAfterEighthInning",
    "BreakAfterNinthInning",
    "BreakAfterTenthInning",
    "BreakAfterEleventhInning",
    "BreakAfterTwelfthInning",
    "BreakAfterThirteenthInning",
    "BreakAfterFourteenthInning",
    "BreakAfterFifteenthInnin",
    "Finished"
];
export const parseLiveGameState = (liveGameState) => {
    if (!liveGameState) {
        return {};
    }
    if (liveGameState.gameTime) {
        return Object.assign(Object.assign({}, liveGameState), { gameTime: shouldCalculateGameTime(liveGameState.gamePart) ? Math.ceil(Math.abs(liveGameState.gameTime) * 1000) : undefined });
    }
    return liveGameState;
};
const shouldCalculateGameTime = (gamePart) => {
    if (!gamePart) {
        return true;
    }
    return BreakGameParts.indexOf(gamePart) < 0;
};
//# sourceMappingURL=parseLiveGameState.js.map